import { IChat } from "../types/IChat";

export function ChatIsUnRead(userId: string, chat: IChat) {
    //Always unread before a staff joins
    if (!chat.Staff_Uid) return true;


    const result = chat.IsClosed ? false : chat.Staff_Uid === userId
        ? new Date(chat.Last_Message_Date) > new Date(chat.Staff_Last_Read)
        : new Date(chat.Last_Message_Date) > new Date(chat.EndUser_Last_Read)

    //console.log('checking ChatIsUnRead', chat?.ConversationId, chat.Last_Message_Date, chat.EndUser_Last_Read, new Date(chat.Last_Message_Date) > new Date(chat.EndUser_Last_Read), result)

    return result;
}

export function ensureUTCDate(dateTime: string) {
    if (!dateTime) return null;

    return dateTime.endsWith('Z') ? dateTime : dateTime + 'Z';
}

export function mergeByProperty(target, source, prop) {
    source.forEach(sourceElement => {
        let targetElement = target.find(targetElement => {
            return sourceElement[prop] === targetElement[prop];
        })
        targetElement ? Object.assign(targetElement, sourceElement) : target.push(sourceElement);
    })
}